import { useMemo } from 'react';
import MenuItemsModal from './MenuItem/MenuItemsModal';
import OrderMethodModal from './order-method/OrderMethodModal';
import LoginModal from './LoginModal';
import InfoModal from './InfoModal';
import FreeProductsModal from './FreeProductsModal';
import useAppState from '../hooks/global/useAppState';
import OtpVerificationModal from './OtpVerificationModal';
import RestaurantClosedModal from './restaurant-closed/RestaurantClosedModal';
import OrderBasketModal from './order-basket';
import useMobileApp from '../hooks/mobile-app/useMobileApp';

export default function GlobalModalsStack() {
  const {
    orderMethodModalProps,
    otpVerificationModalProps,
    freeProductsModalProps,
    menuItemModalProps,
    restaurantClosedModalProps,
    orderBasketModalProps,
  } = useAppState();
  const { isMobileApp } = useMobileApp();

  const { openModal: orderMethodModalOpen } = orderMethodModalProps;
  const { openModal: otpVerificationModalOpen } = otpVerificationModalProps;
  const { openModal: menuItemModalOpen } = menuItemModalProps;
  const { openModal: freeProductsModalOpen } = freeProductsModalProps;
  const { openModal: restaurantClosedModalOpen } = restaurantClosedModalProps;
  const { openModal: orderBasketModalOpen } = orderBasketModalProps;

  const renderOrderMethodModal = useMemo(
    () => orderMethodModalOpen && !isMobileApp && <OrderMethodModal />,
    [orderMethodModalOpen, isMobileApp],
  );

  const renderOtpVerificationModal = useMemo(
    () => otpVerificationModalOpen && <OtpVerificationModal />,
    [otpVerificationModalOpen],
  );

  const renderMenuItemsModal = useMemo(() => menuItemModalOpen && <MenuItemsModal />, [menuItemModalOpen]);

  const renderFreeProductsModal = useMemo(
    () => freeProductsModalOpen && <FreeProductsModal />,
    [freeProductsModalOpen],
  );

  const renderInfoModal = useMemo(() => <InfoModal />, []);

  const renderRestaurantClosedModal = useMemo(
    () => restaurantClosedModalOpen && <RestaurantClosedModal />,
    [restaurantClosedModalOpen],
  );

  const renderOrderBasketModal = useMemo(
    () => <OrderBasketModal open={orderBasketModalOpen} />,
    [orderBasketModalOpen],
  );

  return (
    <>
      <LoginModal />
      {renderOrderMethodModal}
      {renderOtpVerificationModal}
      {renderMenuItemsModal}
      {renderFreeProductsModal}
      {renderInfoModal}
      {renderRestaurantClosedModal}
      {renderOrderBasketModal}
    </>
  );
}
